import React from 'react';

export type FlexProps = {
  align?: 'flex-start' | 'flex-end' | 'center';
  dir?: 'column' | 'row';
} & React.CSSProperties;

const Flex: React.FC<FlexProps> = ({ children, align, dir, ...rest }) => {
  return (
    <div
      style={{
        alignItems: align,
        flexDirection: dir,
        ...rest,
        display: 'flex',
      }}
    >
      {children}
    </div>
  );
};

export default Flex;
